import { SET_BUSINESS_CURRENCIES, SET_CURRENCIES, SET_CURRENCY } from "../../constants/currencyConstants";

const rial = {
  id: 1,
  en_title: "ریال",
  fa_title: "ریال",
};

const initialState = {
  currency: null,
  currencies: [rial],
  businessCurrencies: [rial],
  filteredCurrencies: [],
};

const currencyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENCY:
      return {
        ...state,
        currency: action.currency,
      };
    case SET_CURRENCIES:
      return {
        ...state,
        currencies: action.filtered ? state.currencies : action.currencies,
        filteredCurrencies: action.filtered ? action.currencies : state.filteredCurrencies,
      };
    case SET_BUSINESS_CURRENCIES:
      return {
        ...state,
        lastUpdatedDate: action.lastUpdatedDate,
        businessCurrencies: action.businessCurrencies,
      };
    default:
      return state;
  }
};

export default currencyReducer;
